import React from "react";
import { Button } from "@mui/material";
import { STEP_CONFIG } from "./transportConstants";

/**
 * A small labelled button for adding a step of a given type.
 * size: "medium" (default) | "small"
 */
export const StepTypeButton = ({ type, onClick, size = "medium" }) => {
  const config = STEP_CONFIG[type];
  const Icon = config.icon;
  const isSmall = size === "small";

  return (
    <Button
      variant="outlined"
      color={config.color}
      onClick={() => onClick(type)}
      startIcon={<Icon size={isSmall ? 16 : 18} />}
      sx={{
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 600,
        fontSize: isSmall ? "0.8rem" : "0.875rem",
        px: isSmall ? 1.5 : 2,
        py: isSmall ? 0.5 : 0.75,
        borderWidth: 2,
        "&:hover": { borderWidth: 2 },
      }}
    >
      {config.label}
    </Button>
  );
};